import { Button } from 'antd';
import { useState } from 'react';
import { blue } from '@ant-design/colors';
import { NButton, NButtonProps } from '@next-is-free-monorepo/nif-web-components';

interface ConfirmButtonProps {
  text: string,
  cancelText?: string,
  okText?: string,
  message?: string,
  onConfirm: () => void,
  loading: boolean,
  mainButtonProps?: NButtonProps
}

const ConfirmButton = ({
                         text,
                         cancelText = 'Annulla',
                         okText = 'Ok',
                         message = 'Vuoi continuare?',
                         onConfirm,
                         loading,
                         mainButtonProps
                       }: ConfirmButtonProps) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ width: '100%' }}>
      {open ? (
        <>
          <div style={{
            padding: '20px',
            backgroundColor: blue[0],
            borderRadius: 10,
            border: '1px solid',
            borderColor: blue[1],
            marginBottom: 10
          }}>
            <p style={{ color: blue[4] }}><b>{message}</b></p>
          </div>

          <div style={{ width: '100%', display: 'flex', gap: 10 }}>
            <NButton type={'button'} className={'grow-1'} color={'tertiary'} onClick={() => {
              setOpen(false);
            }} disabled={loading}>{cancelText}</NButton>
            <NButton type={'button'} className={'grow-1'} onClick={() => {
              onConfirm();
              setOpen(false);
            }} loading={loading} disabled={loading}>{okText}</NButton></div>
        </>
      ) : (
        <NButton type={'button'} disabled={loading} loading={loading} className={'w-full'}
                 onClick={() => setOpen(true)} {...mainButtonProps}>{text}</NButton>)}

    </div>);
};
export default ConfirmButton;
